import { TAG_TYPE, type TagInput, type TagType } from "@timeghost/shared";

export interface Tag {
	readonly color: string | null;
	readonly id: string;
	readonly name: string;
	readonly tagType: TagType;
}

export type TagAdd = TagInput;

export type TagUpdate = TagAdd & {
	readonly id: string;
};

const asString = (value: unknown, fallback = ""): string => (typeof value === "string" ? value : fallback);

const parseTagType = (value: unknown): TagType | null => {
	if (value === TAG_TYPE.Project || value === TAG_TYPE.Time) {
		return value;
	}
	if (value === "0" || value === 0) {
		return TAG_TYPE.Project;
	}
	if (value === "1" || value === 1) {
		return TAG_TYPE.Time;
	}
	return null;
};

export const parseTag = (raw: Record<string, unknown>): Tag | null => {
	const id = asString(raw.id).trim();
	const name = asString(raw.name).trim();
	const tagType = parseTagType(raw.tagType);
	if (!(id && name) || tagType === null) {
		return null;
	}

	return {
		id,
		name,
		tagType,
		color: typeof raw.color === "string" && raw.color.trim().length > 0 ? raw.color.trim() : null,
	};
};
